import { Injectable } from '@angular/core';

import { Origin } from '../../../models';
import { TmsWebBaseEditService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class OriginService extends TmsWebBaseEditService<Origin, Origin> {
  constructor() {
    super('Origin', $localize`Origin`);
  }
}
